export default {
  headerLineHeight: 'initial',
};
